__turbopack_context__.v({
  "className": "gilroyfont_d555efed-module__sGmpsq__className",
});
